import {
  combineReducers,
  configureStore,
  createAction,
} from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import stageListReducer from './stageList';
import stageIndexReducer from './stageIndex';
import characterIndexReducer from './characterIndex';
import buttonStatusReducer from './buttonstatus';
import runDisplayReducer from './runDisplay';

const appReducer = combineReducers({
  stageList: stageListReducer,
  stageIndex: stageIndexReducer,
  characterIndex: characterIndexReducer,
  buttonStatus: buttonStatusReducer,
  runDisplay: runDisplayReducer,
});

export const resetRun = createAction('app/resetRun');

const rootReducer = (state, action) => {
  if (action.type === resetRun.type) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

const persistConfig = {
  key: 'tmnt-randomizer',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
